import React from 'react';
import { LoadingDots } from '@balance-web/loading';
import { Stack } from '@balance-web/stack';
import { Text } from '@balance-web/text';
import type { FlexProps } from '@balance-web/flex';
import { Flex } from '@balance-web/flex';

type LoadingDotsProps = Parameters<typeof LoadingDots>[0];

export type LoaderProps = LoadingDotsProps & {
  inline?: boolean;
  visibleLabel?: boolean;
} & FlexProps;

export function Loader({
  /**
   * Should this just be an inline element, or fill the entire parent?
   */
  inline,
  /**
   * Label to display on mouseover, or as description when `visibleLabel` is true
   */
  label,
  /**
   * Make `label` always visible
   */
  visibleLabel,

  /**
   * Rest of the props that LoadingDots takes
   */
  ...props
}: LoaderProps) {
  if (inline) {
    return <LoadingDots label={label} {...props} />;
  }

  return (
    <Flex alignItems="center" flexGrow={1} justifyContent="center" {...props}>
      <Stack align="center" gap="xlarge">
        <LoadingDots label={label} />
        {!!label && visibleLabel && (
          <Text align="center" color="textBody" size="small">
            {label}
          </Text>
        )}
      </Stack>
    </Flex>
  );
}
